import React from "react";

export default function ActionWatchIcon() {
  return (
    <>
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.75 4.0625C8.75 3.64829 8.41421 3.3125 8 3.3125C7.58579 3.3125 7.25 3.64829 7.25 4.0625H8.75ZM8 8H7.25C7.25 8.41421 7.58579 8.75 8 8.75V8ZM11.9375 8.75C12.3517 8.75 12.6875 8.41421 12.6875 8C12.6875 7.58579 12.3517 7.25 11.9375 7.25V8.75ZM14.75 8H14C14 11.3137 11.3137 14 8 14V14.75V15.5C12.1421 15.5 15.5 12.1421 15.5 8H14.75ZM8 14.75V14C4.68629 14 2 11.3137 2 8H1.25H0.5C0.5 12.1421 3.85786 15.5 8 15.5V14.75ZM1.25 8H2C2 4.68629 4.68629 2 8 2V1.25V0.5C3.85786 0.5 0.5 3.85786 0.5 8H1.25ZM8 1.25V2C11.3137 2 14 4.68629 14 8H14.75H15.5C15.5 3.85786 12.1421 0.5 8 0.5V1.25ZM8 4.0625H7.25V8H8H8.75V4.0625H8ZM8 8V8.75H11.9375V8V7.25H8V8Z"
          fill="#AFBACA"
        />
      </svg>
    </>
  );
}
